var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-dialog',{ref:"save-detail",attrs:{"title":"编辑","data":_vm.data,"width":"80%","visible":_vm.visibleSync,"columns":_vm.columnList},on:{"update:visible":function($event){_vm.visibleSync=$event},"confirm":_vm.SaveAs}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b911be2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Surgery/Device/UseDeviceDetail.vue
// module id = null
// module chunks = 